import PropTypes from "prop-types";
import { googleAPIKey } from "../../../helpers/authHelpers";

const GoogleMapIframe = ({
	address
}) => {

	const urlAddress = () => encodeURIComponent([
		address.addressline1,
		address.addressline2,
		address.city,
		address.state,
		address.zip
	].join(" "));

	return (
		<iframe
			height="600"
			sandbox="allow-popups allow-scripts"
			src={`https://www.google.com/maps/embed/v1/place?q=${urlAddress()}&key=${googleAPIKey()}`}
			title="Google Map Directions"
			width="100%"
		/>
	);
};

GoogleMapIframe.propTypes = {
	address: PropTypes.shape({
		addressline1: PropTypes.string,
		addressline2: PropTypes.string,
		city: PropTypes.string,
		state: PropTypes.string,
		zip: PropTypes.string
	}).isRequired
};

export default GoogleMapIframe;
